// Campaign snackbar (bottom left) shared by apps 480, 481 and 484.
// Content and the show/hide decision come from xxsd_railforce.pkg_campaignbanner via two app processes.
window.campaignBanner = (function () {
    'use strict';

    const PROCESS_GET = 'AP_CAMPAIGNBANNER_GET';
    const PROCESS_REACT = 'AP_CAMPAIGNBANNER_REACT';
    const BLOCK = 'campaign-banner';
    // The feedback survey dims the whole screen and catches all clicks; the banner waits until it is closed.
    const BLOCKERS = '.rf-feedback-overlay:not([hidden]), .rf-feedback-share-overlay:not([hidden])';
    // RCB news card in the same corner; the banner stacks above it. A card that is animating out counts as gone.
    const NEWS_CARD = '.rcb-news-snackbar:not(.rcb-news-snackbar--exit):not(.rcb-news-snackbar--preview)';
    const STACK_GAP = 12;

    let card = null;
    let observer = null;

    function el(tag, className, text) {
        const node = document.createElement(tag);
        if (className) {
            node.className = className;
        }
        if (text) {
            node.textContent = text;
        }
        return node;
    }

    function icon(name) {
        const node = el('span', 'fa ' + name);
        node.setAttribute('aria-hidden', 'true');
        return node;
    }

    // The slide-in runs once per login; later pages show the card at rest so it does not look like a new message.
    function seenThisSession(campaigncode) {
        const key = BLOCK + '-' + campaigncode + '-' + $v('pInstance');
        try {
            if (window.sessionStorage.getItem(key)) {
                return true;
            }
            window.sessionStorage.setItem(key, 'Y');
        } catch (e) {
            apex.debug.info('campaignBanner: sessionStorage not available');
        }
        return false;
    }

    function close() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }
        window.removeEventListener('resize', sync);
        if (card) {
            card.remove();
            card = null;
        }
    }

    // offsetHeight and the computed bottom ignore the news card's slide-in transform, so the stack never jumps.
    function stackAboveNews() {
        const news = document.querySelector(NEWS_CARD);
        if (news) {
            const newsBottom = parseFloat(window.getComputedStyle(news).bottom) || 0;
            card.style.bottom = (newsBottom + news.offsetHeight + STACK_GAP) + 'px';
        } else {
            card.style.removeProperty('bottom');
        }
    }

    // Writing hidden queues an attribute mutation even when the value is unchanged, and the observer watches
    // hidden, so an unconditional write would retrigger sync() endlessly while the survey is open.
    function sync() {
        if (card) {
            const blocked = !!document.querySelector(BLOCKERS);
            if (card.hidden !== blocked) {
                card.hidden = blocked;
            }
            stackAboveNews();
        }
    }

    // The survey and the news card load asynchronously and may appear before or after the banner,
    // so watch instead of checking once.
    function watchPage() {
        sync();
        observer = new MutationObserver(sync);
        observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'class'] });
        window.addEventListener('resize', sync);
    }

    function react(reaction) {
        close();
        apex.server.process(PROCESS_REACT, { x01: reaction }, { dataType: 'text' })
            .fail((jqXHR, textStatus, errorThrown) => apex.debug.error('campaignBanner: saving reaction failed', reaction, errorThrown));
    }

    function render(data) {
        const t = data.texts || {};

        card = el('section', BLOCK);
        card.dataset.testid = 'campaign-banner';
        card.setAttribute('aria-label', t.title || '');
        if (seenThisSession(data.campaigncode)) {
            card.classList.add(BLOCK + '--rest');
        }

        const iconBox = el('div', BLOCK + '__icon');
        iconBox.appendChild(icon('fa-calendar-o'));

        const text = el('div', BLOCK + '__text');
        text.appendChild(el('div', BLOCK + '__eyebrow', t.eyebrow));
        text.appendChild(el('div', BLOCK + '__title', t.title));
        const teaser = el('div', BLOCK + '__teaser');
        teaser.appendChild(el('div', null, t.date));
        teaser.appendChild(el('div', null, t.place));
        text.appendChild(teaser);

        const actions = el('div', BLOCK + '__actions');
        const register = el('a', BLOCK + '__button ' + BLOCK + '__button--primary', t.register);
        register.dataset.testid = 'campaign-banner-register';
        register.href = data.url;
        register.target = '_blank';
        register.rel = 'noopener';
        register.appendChild(icon('fa-arrow-right'));
        // Removing the link inside its own click handler cancels the navigation (a detached link cannot navigate),
        // so the card is closed after the browser has opened the Forum tab.
        // Middle click opens the tab without a click event, so auxclick has to save the reaction as well.
        const registered = () => setTimeout(() => react('REGISTERED'), 0);
        register.addEventListener('click', registered);
        register.addEventListener('auxclick', (e) => {
            if (e.button === 1) {
                registered();
            }
        });

        const remind = el('button', BLOCK + '__button ' + BLOCK + '__button--secondary', t.remind);
        remind.dataset.testid = 'campaign-banner-remind';
        remind.type = 'button';
        remind.addEventListener('click', () => react('REMIND'));

        actions.append(remind, register);
        text.appendChild(actions);

        const body = el('div', BLOCK + '__body');
        body.append(iconBox, text);

        const closeButton = el('button', BLOCK + '__close');
        closeButton.dataset.testid = 'campaign-banner-close';
        closeButton.type = 'button';
        closeButton.setAttribute('aria-label', t.close || '');
        closeButton.title = t.close || '';
        closeButton.appendChild(icon('fa-times'));
        closeButton.addEventListener('click', () => react('CLOSED'));

        card.append(body, el('span', BLOCK + '__meta', t.now), closeButton);
        document.body.appendChild(card);
        watchPage();
    }

    function init() {
        // Page 0 also renders inside modal dialog iframes; the banner belongs to the top page only.
        if (card || window.self !== window.top) {
            return;
        }
        apex.server.process(PROCESS_GET, {}, { dataType: 'json' })
            .done((data) => {
                if (data && data.campaigncode && data.url) {
                    render(data);
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => apex.debug.error('campaignBanner: loading failed', errorThrown));
    }

    return { init };
})();